import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http'; 
import { HttpModule } from '@angular/http';
import { tap } from 'rxjs/operators/tap';
import { IViewFoodTypeCountsModel, IViewRefusalCountSinceLastConsumptionModel } from '../interfaces/index';
import { ViewFoodTypeCountsModel, ViewRefusalCountSinceLastConsumptionModel } from '../models/index';

const url = "http://api.reptilebin.com/api/Dashboard/";
//const url = "http://localhost:53148/api/Dashboard/";
const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin':'*',
		'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE',
		'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
	})
};

@Injectable()
export class DashboardService {

  	constructor(public http: HttpClient) {}

  	getFoodTypeCountsByRange(input: { groupId: number, startDate?: Date, endDate?: Date}):Observable<IViewFoodTypeCountsModel[]>{
  		return this.http.post<IViewFoodTypeCountsModel[]>(url+"GetFoodTypeCountsByRange", input, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}

	getRefusalSinceLastConsumptionCount(input: { groupId: number, startDate?: Date, endDate?: Date}):Observable<IViewRefusalCountSinceLastConsumptionModel[]>{
  		return this.http.post<IViewRefusalCountSinceLastConsumptionModel[]>(url+"GetRefusalSinceLastConsumptionCount", input, httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts